import React, {Component} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class ContactFormOverlay extends Component {
	render() {
		return (
			<div className={this.props.isInProgress ? 'd-block' : 'd-none'}>
				<div className={'form-overlay'}>
				</div>
				<CircularProgress color={'primary'} size={80} thickness={1}
				                  classes={{root: 'circular-progress--position'}}/>
			</div>
		)
	}
}

export default ContactFormOverlay;